import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const useStyles = makeStyles({
  plus: {
    ...defaultIcon,
    '&:after, &:before': {
      top: '-.25em',
      left: '50%',
      width: '50%',
      transform: 'translateX(-50%) rotate(-90deg)',
    },
    '&:after': {
      top: 'auto',
      bottom: '-.25em',
      transform: 'translateX(-50%) rotate(90deg)',
    },
  },
});

export default useStyles;
